var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-breadcrumb-item',{class:{ 'breadcrumb-disabled': _vm.disabled }},[_c('div',{class:['breadcrumb-index', { active: _vm.active }]},[_vm._v(_vm._s(_vm.index + 1))]),(!_vm.slim || _vm.active)?_c('p',{class:['breadcrumb-content', { active: _vm.active }]},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }